import {del, post} from './utils/ajax.js';
import {delegateListener} from './utils/delegate-listener.js';
import {defaultAlertModal, getFlow, redirectAnonymous, user} from './utils.js';
import {ProductLikeBIModel} from './BI/models/ProductLikeBIModel.js';
import {track} from './tracking/bi-track.js';
import {currencyToCountryISO} from './tracking/bi.js';

const likeBtnSelector = '.js-like-btn';
delegateListener('click', likeBtnSelector, e => {
  e.preventDefault();
  if (redirectAnonymous()) return;
  const btn = e.target.closest(likeBtnSelector);
  const likeIcon = btn.querySelector('.js-like-icon');
  toggleLikeIcon(likeIcon);
  const productId = btn.dataset.pid;
  const countElem = btn.querySelector('.js-likes-count');
  let likesCount = parseInt(countElem.textContent || '0');
  const apiUrl = `/api/v5/products/${productId}/like`;
  const liked = likeIcon.classList.contains('icon-heart-filled');
  const action = liked ? post : del;
  action(apiUrl, undefined, true, true).then(response => {
    if (response.result == 1) {
      sendBIProductLikeEvent(btn, liked);
      if (liked) {
        sendDataLayerEvent(btn, likesCount);
      }
    } else if (typeof response.result === 'undefined') {
      defaultAlertModal('Ha ocurrido un error');
      toggleLikeIcon(likeIcon);
      likesCount -= liked ? -1 : 1;
    }
  });
  likesCount += liked ? 1 : -1;
  countElem.textContent = Math.max(likesCount, 0) || '';
});

const toggleLikeIcon = icon => {
  icon.classList.toggle('icon-heart-filled');
  icon.classList.toggle('icon-heart');
  icon.classList.toggle('icon-primary-500');
  icon.classList.toggle('icon-black');
  icon.closest("button").classList.toggle('liked');
};

const sendBIProductLikeEvent = (btn, liked) => {
  const countrySellerFicha = document.getElementById('product-sheet')?.dataset.biCountrySeller || '';
  const sellerCurrencyCard = btn.closest('[data-bi-seller-currency]')?.dataset.biSellerCurrency || '';
  const countrySeller = countrySellerFicha || currencyToCountryISO(sellerCurrencyCard);
  const productLikeBIModel = new ProductLikeBIModel(
    user.id,
    parseInt(btn.dataset.pid),
    parseInt(btn.dataset.puid),
    liked ? 'like' : 'dislike',
    getFlow(),
    user.id == btn.dataset.puid,
    document.getElementById('product-sheet') !== null ? 'product' : 'grid',
    countrySeller
  );
  track(productLikeBIModel);
};

const sendDataLayerEvent = (btn, likesCount) => {
  dataLayer.push({
    'event': 'like',
    'item_id': btn.dataset.pid,
    'item_name': btn.dataset.datalayerItemName,
    'item_brand': btn.dataset.datalayerItemBrand,
    'item_category': btn.dataset.datalayerItemCategory,
    'price': btn.dataset.datalayerPrice,
    'quantity': likesCount
  });
};